import store from "../store";
import { selectFloor } from "../store/actions/floorActions";
import {
  focusedStoreSet,
  navigateToStoreSet,
  resetMapFocus,
} from "../store/actions/mapActions";

const EVENTS = [
  {
    command: "goToFloor",
    handle: ({ id }) => store.dispatch(selectFloor(id)),
  },
  {
    command: "focusStore",
    handle: (data) => store.dispatch(focusedStoreSet(data)),
  },
  {
    command: "goToStore",
    handle: (data) => store.dispatch(navigateToStoreSet(data)),
  },
  {
    command: "resetMapFocus",
    handle: (data) => store.dispatch(resetMapFocus(data)),
  },
  {
    command: "reloadMap",
    handle: () => window.location.reload(),
  },
];

class MessageListener {
  init() {
    window.addEventListener("message", this.eventHandler);
    document.addEventListener("message", this.eventHandler);
  }

  eventHandler = (receivedEvent) => {
    if (!receivedEvent.data) {
      return;
    }
    let receivedEventData = receivedEvent.data;
    if (typeof receivedEvent.data === "string") {
      // Trim whitespace from the string and then attempt to parse it as JSON
      try {
        receivedEventData = JSON.parse(receivedEvent.data.trim());
      } catch (e) {
        console.error("Error parsing JSON:", e);
        // Handle the error gracefully, such as setting receivedEventData to null or an empty object
        receivedEventData = null;
      }
    }

    // Assuming you've already parsed receivedEvent.data into receivedEventData
    if (receivedEventData && typeof receivedEventData === "object") {
      const eventHandler = EVENTS.find(
        (event) => event.command === receivedEventData.command
      );

      if (eventHandler && receivedEventData.data) {
        eventHandler.handle(receivedEventData.data);
      } else {
        console.error(
          "Event handler not found or receivedEventData.data is missing."
        );
      }
    } else {
      console.error("Received event data is not valid or could not be parsed.");
    }
  };
}

export default new MessageListener();
